import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { request_new_password } from '../../server/server'
import LoginWrapper from './LoginWrapper'
import ReturnBackIcon from '../../svg/ReturnBackIcon'
import { useHistory } from 'react-router-dom'
import { Oval } from 'react-loader-spinner'

function NewPassword() {
    const [email, setEmail] = useState('')
    const [loading, setLoading] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    const { t } = useTranslation()
    const history = useHistory()

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (email === '') {
            return
        }
        setLoading(true)
        const resp = await onRequestNewPassword(email)
        if (resp.status === 200) {
            history.push('/token', { email })
            setLoading(false)
        } else {
            const error = resp?.data?.message || resp.data
            setErrorMessage(error)
            setLoading(false)
        }
    }

    const onRequestNewPassword = async () => {
        try {
            const response = await request_new_password({ email })
            return response
        } catch (e) {
            return { data: 'Error', success: false }
        }
    }

    return (
        <LoginWrapper>
            <div className="new-password-container">
                <div className="modal-title-new-password">{t('newPassword')}</div>
                <div className="modal-subtitle">{t('enterYourSchoolEmailAndWeWillSendYouALinkToGetBackIntoYourAccount')}</div>
                <div className="new-password-section">
                    <div className="login-form">
                        <form onSubmit={handleSubmit}>
                            <div className="login-form-element-holder">
                                <label>{t('email')}</label>
                                <input className="login-form-input" placeholder={t('email')} value={email} onChange={(e) => setEmail(e.target.value)} />
                            </div>
                            <div className="error-message">{t(errorMessage)}</div>
                            <div className="login-form-request-button">
                                <button className="auth-form-button">
                                    {loading ? <Oval strokeWidth={5} secondaryColor="#7ec5c6" color="#7ec5c6" height={30} width={30} /> : t('sendRequest')}
                                </button>
                            </div>
                        </form>
                        <div style={{ marginTop: '35px' }}>
                            <button
                                className="return-button"
                                onClick={() => {
                                    history.push('/login')
                                }}
                            >
                                <div className="return-button-circle">
                                    <ReturnBackIcon />
                                </div>
                                <label>{t('returnBack')} </label>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </LoginWrapper>
    )
}

export default NewPassword
